module.exports = __webpack_public_path__ + "04_short_gold.c6d3d718.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/04_short_gold.png
// module id = BKik
// module chunks = 0